var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentProperty.id
    ? _c(
        "bj-modal",
        {
          attrs: {
            id: "property-more-details-modal",
            title:
              "" +
              (_vm.editMode ? "Edit " : "") +
              (_vm.currentProperty ? _vm.currentProperty.title : "") +
              " details"
          },
          model: {
            value: _vm.opened,
            callback: function($$v) {
              _vm.opened = $$v
            },
            expression: "opened"
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _vm.editMode
                ? _c(
                    "div",
                    { staticClass: "row gutter-md justify-center q-mb-lg" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12 text-left" },
                        [
                          _vm.hasAppfolioNewIntergation
                            ? _c("p", [
                                _vm._v(
                                  "\n          AppFolio integration is enabled, so many of these attributes will not be able to be edited within Showdigs.\n        "
                                )
                              ])
                            : _vm._e(),
                          _c("bj-form", {
                            ref: "propertyForm",
                            attrs: {
                              fields: _vm.fields,
                              data: _vm.currentProperty
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.saveDetails($event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-xl-4 col-md-6 col-xs-12" },
                        [
                          _c("bj-picture-uploader", {
                            attrs: {
                              "aspect-ratio": 16 / 9,
                              url: _vm.currentProperty.picture,
                              "file-name-only": ""
                            },
                            on: {
                              "update:url": function($event) {
                                _vm.$set(_vm.currentProperty, "picture", $event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _c("div", [
                    _c("ul", [
                      _c("li", [
                        _c("strong", [_vm._v("Prospect communication:")]),
                        _vm.currentProperty.business.should_show_contact
                          ? _c("span", [
                              _vm._v(
                                "\n            business contact details:\n            "
                              ),
                              _vm.currentProperty.business.contact_email
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "q-mr-sm",
                                      attrs: {
                                        href:
                                          "mailto:" +
                                          _vm.currentProperty.business
                                            .contact_email
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.currentProperty.business
                                              .contact_email
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.currentProperty.business
                                .formatted_contact_phone
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "tel:" +
                                          _vm.currentProperty.business.formatted_contact_phone.replace(
                                            " ext ",
                                            ";"
                                          )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.currentProperty.business
                                              .formatted_contact_phone
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n            listing owner\n            "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "tel:" +
                                      _vm.currentProperty.listing_manager
                                        .formatted_public_phone_number
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.currentProperty.listing_manager
                                          .formatted_public_phone_number
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                      ]),
                      _vm.currentProperty.common_agent_notes
                        ? _c("li", [
                            _c("strong", [
                              _vm._v("Property-wide instructions:")
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.currentProperty.common_agent_notes) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _c("li", [
                        _c("strong", [_vm._v("Agent Availability:")]),
                        _c("span", { class: _vm.agentAvailabilityColor }, [
                          _vm._v(_vm._s(_vm.agentAvailability))
                        ])
                      ])
                    ])
                  ]),
              _vm.withUnitsList
                ? _c("units-list", {
                    attrs: {
                      "has-appfolio-new-intergation":
                        _vm.hasAppfolioNewIntergation,
                      "edit-mode": _vm.editMode,
                      "validate-prop": _vm.$v.currentProperty,
                      "current-property": _vm.$v.currentProperty.$model
                    }
                  })
                : _vm._e(),
              _vm.editMode
                ? _c(
                    "div",
                    {
                      staticClass: "q-py-sm",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c("q-btn", {
                        attrs: {
                          rounded: "",
                          label: "Save Property Details",
                          color: "secondary",
                          icon: "save"
                        },
                        on: { click: _vm.saveDetails }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }